/* Better Auth client for the Factumis app (app.factumis.fr). The auth API is
   mounted at /api/auth/* by the app backend (app/server). Same-origin in
   production (the backend serves this SPA build); in dev, Vite proxies
   /api -> http://localhost:3002 (see vite.config.ts), so basePath stays
   relative and works in both environments. */

import { createAuthClient } from 'better-auth/react';
import { organizationClient, magicLinkClient, twoFactorClient } from 'better-auth/client/plugins';
// apiKey est un paquet séparé depuis better-auth v1.5+ (cf. auth.ts côté serveur).
import { apiKeyClient } from '@better-auth/api-key/client';

export const authClient = createAuthClient({
  // same-origin en prod ; en dev le proxy Vite envoie /api -> backend
  basePath: '/api/auth',
  plugins: [organizationClient(), magicLinkClient(), twoFactorClient(), apiKeyClient()],
});

export const { useSession, signIn, signUp, signOut } = authClient;
